import { Avatar, Button, Stack, Typography } from '@mui/material';
import { ISubCategory } from 'API/UniversalRequest/universalRequest';
import { Loader } from 'Components';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import { ApplyToWing } from 'Images';

interface IItemButton {
  subCategory: ISubCategory;
  onclick: () => void;
  onEnterOrEscapeKeyDown: (event: React.KeyboardEvent) => void | null;
  isLoading: boolean;
  isOptions: boolean;
}

export const ItemButton = ({
  isLoading,
  onEnterOrEscapeKeyDown,
  onclick,
  subCategory,
  isOptions,
}: IItemButton) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.UniversalRequest);

  return (
    <Button
      variant='secondary2'
      role={subCategory.link ? 'link' : 'button'}
      sx={{
        p: isOptions ? '16px 16px' : '20px 16px',
        color: '#344266',
        justifyContent: 'start',
        border: '1px solid #1552E81F',
        ':hover': {
          borderColor: 'purple2.main',
          bgcolor: 'white',
          color: '#344266',
        },
      }}
      onClick={onclick}
      onKeyDown={onEnterOrEscapeKeyDown}
      disableFocusRipple
    >
      {isLoading ? (
        <Loader sx={{ height: '100%', overflow: 'hidden' }} size={24} />
      ) : (
        <Stack gap='6px' alignItems='flex-start'>
          {isOptions && (
            <Avatar
              src={ApplyToWing}
              alt=''
              sx={{ width: '20px', height: '20px' }}
            />
          )}
          <Typography fontSize='18px !important' variant='body2'>{`${
            isOptions ? dictionary.optionsTitle : ''
          }${subCategory.title}`}</Typography>
        </Stack>
      )}
    </Button>
  );
};
